import React from "react";

const Details = ({ rowData }) => {
  const fields = [
    { label: "Assigned DateTime", key: "assignedDateTime" },
    { label: "Assigned To", key: "assignedTo" },
    { label: "Assigned To Name", key: "assignedToName" },
    { label: "Assignment Comments", key: "assignmentComments" },
    { label: "Description", key: "description" },
    { label: "Issue Type", key: "issueType" },
    { label: "Status", key: "status" },
    { label: "Status Change Comments", key: "statusChangeComments" },
    { label: "Transaction History ID", key: "transactionHistoryId" },
  ];

  return (
    <div className="main-form">
      <div className="p-fluid formgrid grid">
        {fields.map(({ label, key }) => (
          <div key={key} className="field col-12 md:col-4 mb-3">
            <label>{label}</label>
            <p>{rowData[key] || "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
